// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
}

html,
body {
    height: 100%;
    overflow: hidden;
}

.webgl {
    position: fixed;
    top: 0;
    left: 0;
    outline: none;
}

.jitter {
    animation-duration: 0.3s;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: jittery;
    z-index: -10;
}

.interface-wrapper {
    width: 100%;
    top: 64px;
    left: 64px;
}

.icon-control-container {
    height: 26.5px;
    width: 26.5px;
}

@media only screen and (max-width: 768px) {
    .interface-wrapper {
        width: 100%;
        top: 24px;
        left: 24px;
    }

    .icon-control-container {
        height: 19.5px;
        width: 19.5px;
    }
}

@keyframes jittery {
    10% {
        transform: translate(-0.1px, -0.15px) scale(1, 1);
    }

    20% {
        transform: translate(0.15px, 0.1px) scale(1, 1);
    }

    30% {
        transform: translate(-0.2px, -0.25px) scale(1, 1);
    }

    40% {
        transform: translate(0.05px, 0.1px) scale(1, 1);
    }

    50% {
        transform: translate(-0.025px, -0.05px) scale(1, 1);
    }

    60% {
        transform: translate(0px, 0.075px) scale(1, 1);
    }

    70% {
        transform: translate(-0.075px, -0.1px) scale(1, 1);
    }

    80% {
        transform: translate(0.075px, 0.125px) scale(1, 1);
    }

    90% {
        transform: translate(-0.125px, -0.075px) scale(1, 1);
    }

    100% {
        transform: translate(0.075px, 0.025px) scale(1, 1);
    }
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,sCAAsC;IACtC,6BAA6B;IAC7B,mCAAmC;IACnC,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;QACX,SAAS;QACT,UAAU;IACd;;IAEA;QACI,cAAc;QACd,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,iDAAiD;IACrD;;IAEA;QACI,+CAA+C;IACnD;;IAEA;QACI,iDAAiD;IACrD;;IAEA;QACI,+CAA+C;IACnD;;IAEA;QACI,mDAAmD;IACvD;;IAEA;QACI,8CAA8C;IAClD;;IAEA;QACI,kDAAkD;IACtD;;IAEA;QACI,kDAAkD;IACtD;;IAEA;QACI,oDAAoD;IACxD;;IAEA;QACI,kDAAkD;IACtD;AACJ","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n}\n\nhtml,\nbody {\n    height: 100%;\n    overflow: hidden;\n}\n\n.webgl {\n    position: fixed;\n    top: 0;\n    left: 0;\n    outline: none;\n}\n\n.jitter {\n    animation-duration: 0.3s;\n    animation-timing-function: ease-in-out;\n    animation-fill-mode: forwards;\n    animation-iteration-count: infinite;\n    animation-name: jittery;\n    z-index: -10;\n}\n\n.interface-wrapper {\n    width: 100%;\n    top: 64px;\n    left: 64px;\n}\n\n.icon-control-container {\n    height: 26.5px;\n    width: 26.5px;\n}\n\n@media only screen and (max-width: 768px) {\n    .interface-wrapper {\n        width: 100%;\n        top: 24px;\n        left: 24px;\n    }\n\n    .icon-control-container {\n        height: 19.5px;\n        width: 19.5px;\n    }\n}\n\n@keyframes jittery {\n    10% {\n        transform: translate(-0.1px, -0.15px) scale(1, 1);\n    }\n\n    20% {\n        transform: translate(0.15px, 0.1px) scale(1, 1);\n    }\n\n    30% {\n        transform: translate(-0.2px, -0.25px) scale(1, 1);\n    }\n\n    40% {\n        transform: translate(0.05px, 0.1px) scale(1, 1);\n    }\n\n    50% {\n        transform: translate(-0.025px, -0.05px) scale(1, 1);\n    }\n\n    60% {\n        transform: translate(0px, 0.075px) scale(1, 1);\n    }\n\n    70% {\n        transform: translate(-0.075px, -0.1px) scale(1, 1);\n    }\n\n    80% {\n        transform: translate(0.075px, 0.125px) scale(1, 1);\n    }\n\n    90% {\n        transform: translate(-0.125px, -0.075px) scale(1, 1);\n    }\n\n    100% {\n        transform: translate(0.075px, 0.025px) scale(1, 1);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
